import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "outerWrapper" }
const _hoisted_2 = {
  key: 0,
  class: "cardBox shadowed"
}
const _hoisted_3 = { style: {"min-height":"265px"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-2 pb-3" }
const _hoisted_6 = { class: "cardPartnerLogoParent" }
const _hoisted_7 = { class: "cardPartnerLogoWrapper shadowed" }
const _hoisted_8 = { class: "centered pb-2" }
const _hoisted_9 = { class: "cardTitle pb-2" }
const _hoisted_10 = { class: "p-1 pb-2 cardDescriptionWrapper" }
const _hoisted_11 = { class: "centered w-full cardDescription" }

import { PartnerOffer } from '@/features/partnerOffers/model';
import { InteractionType } from '@/features/analytics/api';
import { logInteraction } from './api';
import OfferTag from './OfferTag.vue';
import { displayModalOffer } from './state';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferCard',
  props: {
    offer: null,
    context: null
  },
  setup(__props: any) {

const props = __props as {
  offer: PartnerOffer,
  context: string,
}



const handleResourceToggle = async () => {
  displayModalOffer(props.context, props.offer);
  logInteraction(props.context, props.offer, InteractionType.CLICK, "card");
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.offer.partner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "full-width cardImage",
              src: __props.offer.cardImage || '/img/partner_offer_card_placeholder.png',
              onClick: handleResourceToggle
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "cardPartnerLogo",
                  style: _normalizeStyle({'background-image': `url('${__props.offer.partner.logoImage || '/img/partner_logo_placeholder.png'}')`})
                }, null, 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.offer.tags.filter(t=>t.id.startsWith('category::')), (tag) => {
                return (_openBlock(), _createBlock(OfferTag, {
                  tag: tag,
                  type: "CATEGORY",
                  key: tag.id
                }, null, 8, ["tag"]))
              }), 128))
            ]),
            _createElementVNode("h1", _hoisted_9, _toDisplayString(__props.offer.name), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(__props.offer.description), 1)
            ]),
            _createElementVNode("div", { class: "pt-2 pr-1 pl-1" }, [
              _createElementVNode("button", {
                class: "cardViewButton",
                onClick: handleResourceToggle
              }, " VIEW RESOURCE ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})